import { render, staticRenderFns } from "./Liabilities.vue?vue&type=template&id=22f472f4&scoped=true"
import script from "./Liabilities.vue?vue&type=script&lang=js"
export * from "./Liabilities.vue?vue&type=script&lang=js"
import style0 from "./Liabilities.vue?vue&type=style&index=0&id=22f472f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f472f4",
  null
  
)

export default component.exports